export default "__VITE_ASSET__fc41e950__"